
<template>
  <v-container>
    <!-- i am clients -> calling client-index -->
    <client-index></client-index>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: {
    ClientIndex: ()=> import('@/components/clients/ClientIndex'),
  },
  data() {
    return {
      key: null,
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>